import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import cx from 'clsx';
import { IconFileAttachmentOutlined } from '@repo/monochrome-icons';
import { scanAttachment } from '@repo/design-system-kit/assets/lotties';
import { LottiePlayer } from '@repo/design-system-kit';
import styles from './processing.module.css';

interface ProcessingProps extends ComponentPropsWithoutRef<'div'> {
  className?: string;
  title?: string;
  description?: ReactNode;
}

export function Processing({
  className,
  title,
  description,
  ...props
}: ProcessingProps): ReactNode {
  return (
    <div className={cx(styles.container, className)} data-testid="processing" {...props}>
      <div className={styles.iconContainer}>
        <IconFileAttachmentOutlined height={24} width={24} />
        <LottiePlayer
          animationData={scanAttachment}
          autoplay
          className={styles.lottieIllustration}
          loop
        />
      </div>
      <div className={styles.content}>
        <div className={cx(styles.title, 'body-standard')}>{title}</div>
        <div className={cx(styles.description, 'body-standard')}>{description}</div>
      </div>
    </div>
  );
}
